<template>
  <div class="cart">
    <div class="cart-main">
      <!-- <div class="header">我的购物车</div> -->
      <div class="routerNameBox">
        <div class="routerItem">
          <router-link to="/mall" class="name"> 首页 </router-link>
          <span class="namePre">></span>
        </div>
        <div class="routerItem">
          <span class="name">我的购物车</span>
        </div>
      </div>
      <div class="cartNull" v-if="isNull">
        <img src="../../assets/images/mall/cartNull1.png" alt="" />
        <p class="text">购物车内暂时没有商品噢！</p>
        <router-link to="/mall"><el-button class="toMall" type="info">继续逛逛</el-button></router-link>
      </div>
      <!-- 有效 -->
      <TableCar
        v-if="!isNull"
        :now="now"
        ref="deleteSelect"
        :tableHead="true"
        @fromtable="getTable"
        :selectAll="selectAll"
        :tableData="dueData"
      ></TableCar>
      <!-- 失效 -->
      <div class="overdue" v-if="!isNull && overdueData.length">已失效商品</div>
      <TableCar
        ref="noValidCommodity"
        v-if="!isNull && overdueData.length"
        :tableHead="false"
        :tableData="overdueData"
      ></TableCar>
      <!-- <div class="beforeFooter" ref="beforeFooter"></div>
      <div class="footer" :class="isPosition ? 'footer-wrap' : ''" ref="footer" v-if="!isNull"> -->
      <div class="footer" ref="footer" v-if="!isNull">
        <div class="left">
          <el-checkbox
            id="cartTable"
            class="selectAll"
            :indeterminate="isIndeterminate"
            v-model="selectAll"
            @click="handleCheckAllChange"
          />
          <div class="selectAllText">全选</div>
          <div class="deletes" style="cursor: pointer" @click="deleteSelect">删除选中商品</div>
        </div>
        <div class="right">
          <div class="goodsNum">
            共 <span class="num">{{ computeTotalCommodity() }}</span>
            件商品 已经选择
            <span class="num">
              <!-- {{ settlement.selectNum }} -->
              {{ getSelectCarNum }} </span
            >件
            <span class="line">|</span>
          </div>
          <div class="totalPrice">
            商品总计:<span>{{ settlement.totalPrice | currency('￥', 2) }}</span>
          </div>
          <div class="discounts">
            <span class="text">活动优惠:</span><span>{{ settlement.discountPrice | currency('-￥', 2) }}</span
            ><span class="line">|</span>
          </div>
          <div class="due">
            <span class="text">应付总额:</span>
            <span class="num">{{
              (settlement.totalPrice - (settlement.discountPrice ? settlement.discountPrice : 0)) | currency('￥', 2)
            }}</span>
          </div>
          <el-button type="danger" class="subBtn" @click="submit"> 下单结算 </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableCar from './components/table.vue'
// import CountDown from '@/components/common/CountDown'
import store from '@/lib/store'
import getData from '@/api/details'

export default {
  name: 'cart',
  components: {
    TableCar
    // CountDown 当前ui中没有关于倒计时的，暂时注释
  },
  data() {
    return {
      isPosition: true /* 底部结算是否定位 */,
      now: 0 /* 当前时间戳 */,
      sxGoodsNull: false,
      checkedItems: [], // 选中商品列表
      checked: false, // 是否选中
      // isIndeterminate: true, // 全选状态
      isSubmit: false, // 是否提交购物车
      // isNull: false, // 购物车是否为空
      num: 1, // 计数器
      countPrice: 0, // 商品单价
      totalPrice: 0, // 总价(优惠前的)
      discountPrice: 0, // 优惠价
      payPrice: 0, // 实际付款
      goodsTotal: 0, // 总商品数量
      list: [],
      cartItems: [],
      // offShelf: [],
      // sellout: [],
      // 这里分隔标记
      selectAll: false, // 是否全选
      settlement: {
        // totalPrice: 0,
        // discountPrice: 0,
        // selectNum: 0,
        // selectTableData: {}
      },
      isIndeterminate: false,
      isNull: false, // 购物车是否为空
      dueData: [],
      overdueData: [],
      pageNo: 1,
      pageSize: 999
    }
  },
  store,
  props: {},
  computed: {
    /**
     * @descripttion: 获取所有商品数量
     * @Author: linyl
     * @Date: 2021-04-25 11:05:13
     * @param {void}
     * @return {void}
     */
    getAllCartNum() {
      let num = 0
      this.dueData.filter((item) => {
        if (!item.gift) {
          num++
        }
      })
      return num
    },
    getSelectCarNum() {
      let num = 0
      if (this.settlement.selectTableData) {
        this.settlement.selectTableData.forEach((item) => {
          if (!item.gift) {
            num++
          }
        })
      }
      return num
    }
  },
  mounted() {
    this.getCartData()
    // this.$nextTick(function() {
    //   window.addEventListener('scroll', this.scrollHandle, true)
    // })
  },
  created() {
    // this.getCartData()
  },
  watch: {
    // checkedItems: {
    //   deep: true,
    //   handler(val) {
    //     this.totalPrice = 0
    //     this.discountPrice = 0
    //     for (let item of val) {
    //       item.addRichCart.forEach((v) => {
    //         this.totalPrice += parseFloat(v.cartItem.snapshotPrice) * parseInt(v.cartItem.quantity || 1)
    //         this.discountPrice +=
    //           parseFloat(v.cartItem.snapshotPrice - v.simpleActivityInfo.activityPrice) *
    //           parseInt(v.cartItem.quantity || 1)
    //       })
    //       this.totalPrice += parseFloat(item.cartItem.snapshotPrice) * parseInt(item.cartItem.quantity)
    //       this.discountPrice +=
    //         parseFloat(
    //           item.cartItem.snapshotPrice -
    //             (item.isActivity ? item.simpleActivityInfo.activityPrice : item.cartItem.snapshotPrice)
    //         ) * parseInt(item.cartItem.quantity)
    //     }
    //   }
    // }
  },
  methods: {
    /**
     * @descripttion: 计算商品总数
     * @Author: lujing
     * @Date: 2021-04-21 16:35:04
     * @param {void}
     * @return {num}商品总数
     */
    computeTotalCommodity() {
      let num = 0
      this.dueData.forEach((res) => {
        if (!res.gift) {
          num++
        }
        res.children &&
          res.children.forEach(() => {
            num++
          })
      })
      return num
    },
    // 懒加载购物车列表
    // scrollHandle() {
    //   const offset = this.$refs.footer.getBoundingClientRect() // vue中，使用this.$el获取当前组件的根元素
    //   const offsetTop = offset.top
    //   const offsetBottom = offset.bottom
    //   // const offsetHeight = offset.height
    //   // 进入可视区域
    //   if (offsetTop <= window.innerHeight && offsetBottom >= 0) {
    //     this.pageSize += 10
    //   } else {
    //   }
    // },
    // 定位底部结算
    // scrollHandle() {
    //   const offset = this.$refs.beforeFooter.getBoundingClientRect() // vue中，使用this.$el获取当前组件的根元素
    //   const offsetTop = offset.top
    //   const offsetBottom = offset.bottom
    //   // const offsetHeight = offset.height
    //   // 进入可视区域
    //   if (offsetTop <= window.innerHeight && offsetBottom >= 0) {
    //     this.isPosition = false
    //   } else {
    //     this.isPosition = true
    //   }
    // },
    // 倒计时结束 重新调接口查询
    handleCountDown() {
      this.getCartData()
    },
    // 重置数据
    initData() {
      this.sxGoodsNull = false
      this.selectAll = false
      // this.checkedItems = []
      this.checked = false
      this.isIndeterminate = true
      this.isSubmit = false
      this.isNull = false
      this.num = 1
      this.countPrice = 0
      this.totalPrice = 0
      this.discountPrice = 0
      this.payPrice = 0
      this.goodsTotal = 0
      this.list = []
      this.cartItems = []
      this.dueData = []
      this.overdueData = []
      // this.offShelf = []
      // this.sellout = []
    },
    // 获取购物车数据
    getCartData() {
      // let data = {
      //   pageNo: this.pageNo,
      //   pageSize: this.pageSize
      // }

      this.now = new Date().getTime()
      getData.getCartList({ terminal: 1, vmId: 1 }).then(
        (res) => {
          this.initData()
          if (res.status === 200 && res.data.length) {
            res.data.map((res) => {
              // 当前是否是搭配购
              let isCollocation = false
              // 当前是否是买赠
              let mz = false
              if (res.status === 1) {
                // 判断当前是什么类型的活动
                const actionItem = JSON.parse(res.activityItemInfoDto)
                if (actionItem && actionItem.activityInfoDto && actionItem.activityInfoDto.activityType === 2) {
                  isCollocation = true
                }
                if (actionItem && actionItem.activityInfoDto && actionItem.activityInfoDto.activityType === 21) {
                  mz = true
                }

                // res.children = res.bizCollectionCartItemVOS ? res.bizCollectionCartItemVOS : []
                // this.$set(res, 'isSelect', false)
                // console.log(JSON.parse(res.activityItemInfoDto))
                // res.activityItemInfoDto = JSON.parse(res.activityItemInfoDto)
                // console.log(res)
                this.dueData.push(res)
                // // 买赠的商品
                if (res.bizCollectionCartItemVOS) {
                  res.bizCollectionCartItemVOS.forEach((item) => {
                    this.$set(item, 'collocation', isCollocation)
                    this.$set(item, 'gift', mz)
                    if (mz) {
                      this.$set(item, 'snapshotPrice', 0)
                      this.$set(item, 'acId', res.activityId)
                    }
                    this.dueData.push(item)
                  })
                }
              } else if (res.status === -2) {
                this.overdueData.push(res)
              }
              setTimeout(() => {
                this.$refs.deleteSelect && this.$refs.deleteSelect.expandAllRow()
                this.$refs.noValidCommodity && this.$refs.noValidCommodity.expandAllRow()
              }, 50)
            })
            // res.data.forEach((val) => {
            //   this.dueData.push(val.filter())
            //   this.cartItems.push(...val.cartItems.normal)
            //   this.offShelf.push(...val.cartItems.offShelf)
            //   this.sellout.push(...val.cartItems.sellout)
            // })
            const nowTime = new Date().getTime()
            this.cartItems.forEach((val) => {
              val.isActivity = this.isActivity(val)
              val.itemType = val.cartItem.type === 8 ? 'car' : 'goods'
              val.activity = val.isActivity ? val.simpleActivityInfo.activityType : null
              val.activityId = val.isActivity ? val.simpleActivityInfo.activityId : null
              val.activityClosed = val.isActivity ? nowTime >= val.simpleActivityInfo.realEndTime : true
              val.countTitle = val.isActivity
                ? nowTime < val.simpleActivityInfo.realStartTime
                  ? '距离活动开始时间：'
                  : '距离活动结束时间：'
                : ''
              val.countEndTime = val.isActivity
                ? nowTime < val.simpleActivityInfo.realStartTime
                  ? val.simpleActivityInfo.realStartTime
                  : val.simpleActivityInfo.realEndTime
                : ''
            })
            // this.$store.commit('getCartNum', [...this.cartItems, ...this.offShelf, ...this.sellout].length)
          } else {
            this.isNull = true
            if (!res.data.length) {
              this.isNull = true
            }
          }
          // this.dueData.forEach((item) => {
          //   if (item.activityItemInfoDto) {
          //     console.log(item.activityItemInfoDto)
          //     item.activityItemInfoDto = JSON.parse(item.activityItemInfoDto)
          //   }
          // })
          // console.log(this.dueData)
        },
        (res) => {
          if (res.message === 'Request failed with status code 401') {
            this.loadingInstance().close()
          } else {
            this.$feedback(res.message)
            this.loadingInstance().close()
          }
        }
      )
    },
    // 已选商品属性
    // getSelectedAttr(sku) {
    //   if (sku && sku.attrs && 'length' in sku.attrs) {
    //     return sku.attrs.reduce((total, next, cindex, arr) => {
    //       return total + (cindex === arr.length - 1 ? next.attrVal : `${next.attrVal}/`)
    //     }, '')
    //   }
    //   return ''
    // },
    // 全选
    // handleCheckAllChangeText() {
    //   this.checkedItems = this.cartItems
    //   this.selectAll = true
    //   this.isIndeterminate = false
    // },
    handleCheckAllChange(val) {
      this.selectAll = val
      this.checkedItems = val ? this.cartItems : []
      this.isIndeterminate = false
    },
    // 单选
    // handleCheckedItemsChange(value) {
    //   let checkedCount = value.length
    //   this.selectAll = checkedCount === this.cartItems.length
    //   this.isIndeterminate = checkedCount > 0 && checkedCount < this.cartItems.length
    // },
    submit() {
      this.$refs.deleteSelect.goSubmit(this.settlement.selectTableData)
    },
    getTable(data) {
      this.settlement = { ...data }
      // 排除赠品的情况
      // let num = this.dueData.filter((item) => !item.gift).length
      if (this.settlement.selectTableData.length === this.dueData.length) {
        this.handleCheckAllChange(true)
      } else if (this.settlement.selectTableData.length > 0) {
        this.isIndeterminate = this.settlement.selectTableData.length < this.dueData.length
      } else {
        this.handleCheckAllChange(false)
      }
    },
    deleteSelect() {
      this.$refs.deleteSelect.batchRemove(this.settlement.selectTableData)
    }
  }
}
</script>

<style lang="scss" scoped>
.cart {
  // margin-left: 280px;
  width: 100%;
  height: 100%;
  background: #f9f9f9;
  margin: 0;
  padding-top: 10px;
  .cart-main {
    width: 1360px;
    background: #ffffff;
    margin: 60px auto;
    margin-bottom: 10px;
    box-shadow: 0px 1px 0px 0px rgba(224, 224, 224, 1);
    .header {
      float: left;
      // position: relative;
      margin-top: -40px;
      height: 22px;
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      width: 80px;
      height: 22px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #333333;
    }
    .cartNull {
      width: 264px;
      height: 400px;
      margin: 0px auto;
      display: flex;
      flex-direction: column;
      // justify-content: center;
      align-items: center;
      img {
        margin-top: 60px;
      }
      .text {
        height: 22px;
        font-size: 16px;
        font-weight: 400;
        color: #777777;
        line-height: 22px;
        letter-spacing: 1px;
        margin-bottom: 27px;
        text-align: center;
      }
      .toMall {
        width: 133px;
        height: 40px;
        background: #040404;
        border-radius: 0;
      }
    }
    // .tableRow {
    //   text-align: center;
    //   .tableCell {
    //     .goodsMessage {
    //       display: flex;
    //       .goodsImg {
    //         width: 202px;
    //         height: 143px;
    //       }
    //       .text {
    //         margin-top: 17px;
    //         margin-left: 14px;
    //         .name {
    //           max-width: 300px;
    //           min-height: 25px;
    //           font-size: 18px;
    //           text-align: left;
    //           font-family: PingFangSC-Medium, PingFang SC;
    //           font-weight: 500;
    //           color: #333333;
    //           line-height: 25px;
    //         }
    //         .type {
    //           margin-top: 10px;
    //           text-align: left;
    //           min-height: 22px;
    //           font-size: 16px;
    //           font-family: PingFangSC-Regular, PingFang SC;
    //           font-weight: 400;
    //           color: #333333;
    //           line-height: 22px;
    //         }
    //       }
    //     }
    //     .price {
    //       height: 25px;
    //       font-size: 18px;
    //       font-family: PingFangSC-Regular, PingFang SC;
    //       font-weight: 400;
    //       color: #333333;
    //       line-height: 25px;
    //     }
    //   }
    // }
    .overdue {
      margin-top: 20px;
      margin-bottom: 5px;
      padding-left: 62px;
      height: 28px;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 28px;
      border-bottom: 1px solid #ebeef5;
    }
    .footer-wrap {
      position: fixed;
      bottom: 0;
      z-index: 10;
      background: #fff;
      width: 1360px;
    }
    .footer {
      height: 56px;
      display: flex;
      justify-content: space-between;
      .left {
        display: flex;
        align-items: center;
        .selectAll {
          margin-left: 20px;
          margin-right: 12px;
        }
        .selectAllText {
          width: 32px;
          height: 22px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
          margin-right: 45px;
        }
        .deletes {
          text-decoration: underline;
          text-decoration-color: #333333;
          width: 96px;
          height: 22px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
        }
        .deletes :hover {
          color: #9ea0a1;
        }
      }
      .right {
        display: flex;
        align-items: center;
        .goodsNum {
          height: 22px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 22px;
          .num {
            color: #c6001f;
          }
          .line {
            margin-left: 10px;
          }
        }
        .totalPrice {
          margin-left: 15px;
          height: 22px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 22px;
        }
        .discounts {
          display: flex;
          align-items: center;
          margin-left: 25px;
          height: 22px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 22px;
          .text {
            width: 70px;
          }
          .line {
            width: 1px;
            margin-left: 25px;
            height: 22px;
          }
        }
        .due {
          margin-right: 44px;
          margin-left: 15px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          height: 37px;
          display: flex;
          align-items: center;
          .num {
            margin-left: 10px;
            font-size: 26px;
            font-weight: 500;
            color: #c6001f;
            line-height: 37px;
          }
          .text {
            width: 70px;
          }
        }
        .subBtn {
          width: 230px;
          height: 56px;
          color: #fff;
          font-size: 20px;
          font-weight: 600;
          background: #c6001f;
          border-radius: 0;
        }
      }
    }
  }
}
.routerNameBox {
  padding: 20px 0 28px 0;
  font-size: 16px;
  color: #777777;
  .routerItem {
    display: inline-block;
    .namePre {
      margin: 0 6px;
    }
    &:last-child {
      color: #333333;
    }
  }
}
</style>
